import VerticalBox from './VerticalBox';

export type { VerticalBoxProps } from './VerticalBox';

export default VerticalBox;
